import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesLeadActivitiesView } from "src/components/views/erp/sales/crm/salesLeadActivities/SalesLeadActivitiesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/crm/salesLeadActivities")({
	staticData: { title: i18n.t("sales_lead_activities"), legacyViewKey: "salesLeadActivitiesView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesLeadActivitiesView />;
}
